import { Component } from '@verndale/core';

class linkCollapsibleContent extends Component {
  setupDefaults() {
    this.dom = {
      $collapsibleAction: this.el.querySelectorAll('.link-collapsible-content .link--caret'),
    };
  }

  addListeners() {
    this.dom.$collapsibleAction.forEach((el) => {
      el.addEventListener('click', this.toggleContent.bind(this));
    });
  }

  toggleContent(el){
    el.currentTarget.classList.toggle('active');
    const content = el.currentTarget.nextElementSibling;
    if (content.classList.contains('show')) {
      content.classList.remove('show');
    } else {
      content.classList.add('show');
    }
  }
}

export default linkCollapsibleContent;
